"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PARENT_ID = exports.INLINE_PARENT_ID = exports.INLINE_IFRAME_ID = exports.IFRAME_ID = void 0;
const PARENT_ID = exports.PARENT_ID = 'hubspot-messages-iframe-container';
const INLINE_PARENT_ID = exports.INLINE_PARENT_ID = 'hubspot-conversations-inline-parent';
const INLINE_IFRAME_ID = exports.INLINE_IFRAME_ID = 'hubspot-conversations-inline-iframe';
const IFRAME_ID = exports.IFRAME_ID = 'hubspot-conversations-iframe';